import { commonEnv } from "./environment.common";


const env : Partial<typeof commonEnv> = {};
export const Environment = Object.assign(commonEnv, env);

